import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link, useSearchParams } from 'react-router-dom';

import { request, createUrl } from 'app/utils';
import { useSchool } from 'features/school';
import { Button, Flex, Section, Typography } from 'components';

import { ExamsCard, ExamsListResponse, useExams } from 'features/exams';

import usestorage from 'app/utils/storage';

import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import './styles.scss';

import { factoryCardSearch } from '../examsCard';

SwiperCore.use([Pagination]);

interface ExamsListProps {
  local: 'dashboard' | 'products';
  productSlug?: string;
}

const ExamsList = ({ local, productSlug }: ExamsListProps): ReactElement => {
  const { exams, setExams, clearExams } = useExams();
  const { apiGatewayUrl } = useSchool();

  const [searchText] = useState('');
  const [order] = useState<number>(0);
  const [page] = useState<number>(1);
  const [size] = useState<number>(8);

  const storage = usestorage('localStorage');
  const currentDashboard = storage.get('currentDashboard');

  const [searchParams] = useSearchParams();
  const currentDashboardArea = searchParams.get('dashboardAreaUuid');

  const fetchExams = useCallback(async () => {
    await Promise.all([
      request<ExamsListResponse>({
        url: productSlug ? `/api/v1/School/ProductContentPracticeExams/${productSlug}` : '/api/v1/School/PracticeExam/Search',
        method: 'get',
        baseURL: apiGatewayUrl,
        params: productSlug
          ? {}
          : {
              searchFor: searchText,
              searchOrder: order,
              page,
              size,

              ...(currentDashboard ? { dashboardUuid: currentDashboard } : {}),
              ...(currentDashboardArea ? { dashboardAreaUuid: currentDashboardArea } : {}),
            },
      }).then(({ data }) => {
        setExams(data);
      }),
    ]);
  }, [productSlug, searchText, order, page, size, currentDashboard, currentDashboardArea]);

  let showExams = true;
  let hat = 'Provas e Simulados';
  let title = 'Avaliações';

  useEffect(() => {
    if (showExams) fetchExams();
  }, [showExams]);

  useEffect(() => {
    return () => {
      clearExams();
    };
  }, []);

  return showExams && !!exams?.length ? (
    <>
      <Flex bg="dark_150" borderTopWidth={local === 'products' ? 1 : 0} borderTopStyle="solid" borderTopColor="gray_200" py={{ d: 80, t: 60, m: 40 }}>
        <Section flexDirection="column">
          <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end" flexGrow={0} mb={{ m: 3, d: 4 }}>
            <Flex flexDirection="column" flexGrow={0}>
              {!!hat && (
                <Typography type="type3" color="white" upper mb={2}>
                  {hat}
                </Typography>
              )}

              <Typography type="type8" fontWeight="bold" color="white">
                {title}
              </Typography>
            </Flex>

            <Flex flexGrow={0} mt={{ m: 2, t: 0 }}>
              <Link to={createUrl('exams/list')}>
                <Button height={{ m: 40 }}>Ver todas</Button>
              </Link>
            </Flex>
          </Flex>

          <Swiper
            loop={false}
            autoplay={{
              delay: 1000,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            spaceBetween={20}
            pagination={{
              clickable: true,
              renderBullet: (index: any, className: any) => {
                return '<div class="' + className + '"></div>';
              },
            }}
            className="exams-list"
          >
            {exams.map((exam, index) => (
              <SwiperSlide key={`report-item-${index.toString()}`}>
                <ExamsCard view="grid" {...factoryCardSearch(exam)} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Section>
      </Flex>
    </>
  ) : (
    <></>
  );
};

export default ExamsList;
